/**
 * ZILURA quick view: the "More images" pill on product cards opens a swipeable photo gallery with
 * the title, price, wishlist heart, Add to cart and a link to the full product page, so shoppers can
 * browse every photo from the collection grid.
 * Photos come from the card's <script type="application/json" data-zl-qv-media> (snippets/zilura-card-extras.liquid);
 * price and Add to cart are clones of the card's own controls (zilura-atc keeps every copy in sync).
 */
(function () {
  if (window.zlQuickView) return;

  let modal;
  let lastFocus;

  const el = (tag, className, attrs = {}) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    Object.entries(attrs).forEach(([k, v]) => node.setAttribute(k, v));
    return node;
  };

  const build = () => {
    modal = el('div', 'zl-qv', { role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'ZlQvTitle' });
    modal.hidden = true;
    modal.innerHTML = `
      <div class="zl-qv__backdrop" data-zl-qv-close></div>
      <div class="zl-qv__box">
        <button type="button" class="zl-qv__x" data-zl-qv-close aria-label="Close">
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" /></svg>
        </button>
        <div class="zl-qv__media">
          <div class="zl-qv__track" data-zl-qv-track tabindex="0" aria-label="Product photos"></div>
          <button type="button" class="zl-qv__nav zl-qv__nav--prev" data-zl-qv-step="-1" aria-label="Previous photo">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" /></svg>
          </button>
          <button type="button" class="zl-qv__nav zl-qv__nav--next" data-zl-qv-step="1" aria-label="Next photo">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" /></svg>
          </button>
        </div>
        <div class="zl-qv__dots" data-zl-qv-dots></div>
        <div class="zl-qv__info">
          <div class="zl-qv__head">
            <h2 class="zl-qv__title" id="ZlQvTitle"></h2>
            <div data-zl-qv-wish></div>
          </div>
          <div class="zl-qv__price" data-zl-qv-price></div>
          <div class="zl-qv__atc" data-zl-qv-atc></div>
          <a class="zl-qv__link" data-zl-qv-link href="#">View full product</a>
        </div>
      </div>`;
    document.body.appendChild(modal);

    const track = modal.querySelector('[data-zl-qv-track]');

    modal.addEventListener('click', (event) => {
      if (event.target.closest('[data-zl-qv-close]')) return close();
      const step = event.target.closest('[data-zl-qv-step]');
      if (step) go(current() + Number(step.dataset.zlQvStep));
      const dot = event.target.closest('[data-zl-qv-dot]');
      if (dot) go(Number(dot.dataset.zlQvDot));
    });

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
      else if (event.key === 'ArrowRight') go(current() + 1);
      else if (event.key === 'ArrowLeft') go(current() - 1);
      else if (event.key === 'Tab') trapFocus(event);
    });

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        ticking = false;
        updateUi();
      });
    });
  };

  const track = () => modal.querySelector('[data-zl-qv-track]');
  const slides = () => track().children.length;
  const current = () => {
    const t = track();
    return t.clientWidth ? Math.round(t.scrollLeft / t.clientWidth) : 0;
  };

  const go = (index) => {
    const t = track();
    const i = Math.max(0, Math.min(slides() - 1, index));
    t.scrollTo({ left: i * t.clientWidth, behavior: 'smooth' });
  };

  const updateUi = () => {
    const i = current();
    const n = slides();
    modal.querySelectorAll('[data-zl-qv-dot]').forEach((d, k) => d.setAttribute('aria-current', String(k === i)));
    modal.querySelector('.zl-qv__nav--prev').disabled = i <= 0;
    modal.querySelector('.zl-qv__nav--next').disabled = i >= n - 1;
  };

  const trapFocus = (event) => {
    const items = [...modal.querySelectorAll('button:not([disabled]), a[href], input, [tabindex="0"]')].filter(
      (n) => n.offsetParent !== null
    );
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const open = (trigger) => {
    const card = trigger.closest('.product-card-wrapper') || trigger.closest('.card-wrapper');
    const data = card && card.querySelector('[data-zl-qv-media]');
    if (!data) return;
    let media = [];
    try {
      media = JSON.parse(data.textContent);
    } catch (e) {
      return;
    }
    if (!modal) build();

    const link = card.querySelector('a[id^="CardLink-"]') || card.querySelector('.card__heading a');
    const title = link ? link.textContent.trim() : '';
    const url = link ? link.getAttribute('href') : '#';

    const t = track();
    t.innerHTML = '';
    media.forEach((m, i) => {
      const slide = el('div', 'zl-qv__slide', { role: 'group', 'aria-label': `Photo ${i + 1} of ${media.length}` });
      const img = el('img', '', {
        src: m.src,
        alt: m.alt || title,
        width: String(m.w || 1),
        height: String(m.h || 1),
        loading: i === 0 ? 'eager' : 'lazy',
        draggable: 'false',
      });
      slide.appendChild(img);
      t.appendChild(slide);
    });

    const dots = modal.querySelector('[data-zl-qv-dots]');
    dots.innerHTML = '';
    dots.hidden = media.length < 2;
    media.forEach((_, i) => {
      dots.appendChild(el('button', 'zl-qv__dot', { type: 'button', 'data-zl-qv-dot': String(i), 'aria-label': `Show photo ${i + 1}` }));
    });
    modal.querySelectorAll('.zl-qv__nav').forEach((n) => (n.hidden = media.length < 2));

    modal.querySelector('#ZlQvTitle').textContent = title;
    const viewLink = modal.querySelector('[data-zl-qv-link]');
    viewLink.href = url;

    const fill = (selector, source) => {
      const slot = modal.querySelector(selector);
      slot.innerHTML = '';
      if (source) slot.appendChild(source.cloneNode(true));
    };
    fill('[data-zl-qv-price]', card.querySelector('.card-information .price'));
    fill('[data-zl-qv-atc]', card.querySelector('zilura-atc'));
    const wish = card.querySelector('[data-zl-wish]');
    fill('[data-zl-qv-wish]', wish);
    const wishCopy = modal.querySelector('[data-zl-qv-wish] [data-zl-wish]');
    if (wishCopy) wishCopy.classList.replace('zl-wish--card', 'zl-wish--inline');

    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('overflow-hidden');
    t.scrollLeft = 0;
    if (window.zlWishlist) window.zlWishlist.sync(modal);
    window.requestAnimationFrame(() => {
      modal.classList.add('is-open');
      updateUi();
      modal.querySelector('.zl-qv__x').focus({ preventScroll: true });
    });
  };

  const close = () => {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
    modal.querySelector('[data-zl-qv-atc]').innerHTML = '';
    if (!document.querySelector('cart-drawer.active, details[open] > .search-modal')) {
      document.body.classList.remove('overflow-hidden');
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-zl-qv]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    open(trigger);
  });

  window.zlQuickView = { open, close };
})();
